import flattenMessages from '../flattenMessages';
import en from './en.json';
import es from './es.json';
import ru from './ru.json';
import zh from './zh.json';

export default {
  en: flattenMessages(en, 'payment'),
  es: flattenMessages(es, 'payment'),
  ru: flattenMessages(ru, 'payment'),
  zh: flattenMessages(zh, 'payment'),
};
